/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProOnboardChoose.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import CompanySignUpForm from './partials/CompanySignUpForm';
import {
  register,
  fetchUser,
  companySignUp,
} from '../actions';


class ProOnboardChoose extends OzComponent {

  static need = [
  ]

  renderChoices() {
    let choices = [
      {
        name: 'Connect Booking System',
        description: "Connect your existing booking system to EscapeSpy, enabling users to instantly book your rooms on the search results page.",
      },
      {
        name: 'EscapeSpy Pro Booking',
        description: "Use EscapeSpy's booking system to manage reservations for your escape rooms. Includes instant bookings on search results page.",
      }
    ];
    return null;
  }

  render() {
    return (
      <Wrapper className="ProOnboardChoose">
        {this.renderChoices()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    fetchUser,
    companySignUp,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProOnboardChoose);



/** WEBPACK FOOTER **
 ** ./src/components/ProOnboardChoose.js
 **/